import { useEffect, useState } from "react";
import { http, fmtErr, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import ImageUpload from "@/components/ImageUpload";

export default function PaymentQRSettings() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => { http.get("/admin/settings/payment-qr").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;

  const save = async (patch) => {
    try {
      const r = await http.put("/admin/settings/payment-qr", { ...cfg, ...patch });
      setCfg(r.data);
      toast.success("Payment QR settings saved");
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div className="card" data-testid="payment-qr-settings">
      <h3 className="font-serif text-2xl mb-1">Payment QR Code</h3>
      <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>
        Shown on the Guest Portal bill so guests can pay by UPI. Scanning never marks a bill paid — you verify each payment.
      </p>
      <label className="flex items-center gap-3 mb-4 text-sm cursor-pointer">
        <input type="checkbox" style={{ width: "auto" }} data-testid="qr-enabled" checked={!!cfg.enabled}
          onChange={(e) => save({ enabled: e.target.checked })} />
        Enable QR payment in Guest Portal
      </label>
      {cfg.image_url ? (
        <div className="mb-3">
          <img src={fileUrl(cfg.image_url)} alt="Payment QR" className="w-32 h-32 object-contain rounded-lg border p-2" style={{ borderColor: "var(--border)", background: "#fff" }} data-testid="qr-preview" />
        </div>
      ) : <p className="text-sm mb-3" style={{ color: "var(--muted)" }}>No QR uploaded yet.</p>}
      <div className="flex flex-wrap gap-2 mb-4">
        <ImageUpload testid="qr-upload" label={cfg.image_url ? "Replace Payment QR" : "Upload Payment QR"} onUploaded={(url) => save({ image_url: url })} />
        {cfg.image_url && (
          <button data-testid="qr-remove" onClick={() => save({ image_url: "" })} className="btn-outline">Remove QR</button>
        )}
      </div>
      <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Payment display name</label>
      <input data-testid="qr-name" value={cfg.display_name || ""} className="mb-3"
        onChange={(e) => setCfg({ ...cfg, display_name: e.target.value })} onBlur={() => save({})} />
      <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Payment instructions (optional)</label>
      <textarea data-testid="qr-instructions" rows="2" value={cfg.instructions || ""} className="mb-3"
        onChange={(e) => setCfg({ ...cfg, instructions: e.target.value })} onBlur={() => save({})} />
    </div>
  );
}
